import icons from '@/mixins/icons.js'
export default {
  name: 'DropdownInPlace',
  data () {
    return {
      showDDList: false
    }
  },
  props: ['listOfItems'],
  mixins: [icons],
  created () {},
  mounted () {},
  computed: {
    selectedItem () {
      return this.listOfItems.filter(function (item) {
        return item._selected
      })[0]
    }
  },
  methods: {
    itemClicked (clickedItem) {
      if (!clickedItem._selected) {
        this.listOfItems.map(function (anItem) {
          anItem._selected = false
        })
        clickedItem._selected = true
      }
      this.showDDList = false
    },
    closeList () {
      console.log('closeList')
      this.showDDList = false
    }
  }
}
